import './styles/social.scss';
import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import RequestManager from "../../requests/RequestManager";
import LogoutTask from '../../requests/tasks/user/LogoutTask'
import { playFullMedia } from '../../actions/playmedia';
import UtilsProfile from './../../utils/Profile';
import store from './../../store';
import Device from '../../devices/device';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage'
import Utils from '../../utils/Utils';

const doLogout=()=>{
  const service = new LogoutTask();

  RequestManager.addRequest(service).then((resp) => {
    if (resp.response) {

      let ui=DeviceStorage.getItem('__UUID__');
      const hadLoginSuccess = DeviceStorage.getItem('hadLoginSuccess');
      //let xdk = DeviceStorage.getItem('xdk');  //Ahora al hacer logout en aaf La bandera se limpia y redirige una vez mas a XDK
      store.dispatch(playFullMedia({ src: null,  event: null }));
      DeviceStorage.clear();

      const platform = Device.getDevice().getPlatform();
      const isAndroid = platform === 'android';
      try {
        if (isAndroid && window.AndroidPlayerInterface) {
          window.AndroidPlayerInterface.getUserInformation();
        }
      } catch (error) {
        console.log('[ERROR]-error on getUserInformation', error);
      }

      DeviceStorage.setItem('__UUID__', ui);
      DeviceStorage.setItem('IsLogOut', true);
      if (hadLoginSuccess === '1') DeviceStorage.setItem('hadLoginSuccess', '1');
      //DeviceStorage.setItem('xdk', xdk);
      Utils.cleanCustomAttribute();
      window.location.href='/';

      // Youbora
      if(window.youboraTrackingPlugin){
        if(window.youboraTrackingPlugin.storage){
          if(window.youboraTrackingPlugin.storage.removeLocal
            && typeof window.youboraTrackingPlugin.storage.removeLocal === "function"){
            window.youboraTrackingPlugin.storage.removeLocal('data');
          }
          if(window.youboraTrackingPlugin.storage.removeSession
            && typeof window.youboraTrackingPlugin.storage.removeSession === "function"){
            window.youboraTrackingPlugin.storage.removeSession('data');
          }
        }
        if(window.youboraTrackingPlugin.restartViewTransform
          && typeof window.youboraTrackingPlugin.restartViewTransform === "function"){
          window.youboraTrackingPlugin.restartViewTransform();
        }
        if(window.youboraTrackingPlugin.setOptions
          && typeof window.youboraTrackingPlugin.setOptions === "function"){
          window.youboraTrackingPlugin.setOptions();
        }
      }
      if(window.youboraAnalyticsPlugin
        && window.youboraAnalyticsPlugin.infinity
        && typeof window.youboraAnalyticsPlugin.infinity.fireSessionStop === "function"){
        window.youboraAnalyticsPlugin.infinity.fireSessionStop();
      }

    }
  }).catch((err) => {
    console.error(err);
  });
};

const ModalProfile = (props = {}) => {

  const buttons = [];
  let enableAbout = false; // Valor por defecto en caso de no tenerlo definido desde propiedades
  if(typeof props.enableAbout != 'undefined' && props.enableAbout !== null){
    enableAbout = props.enableAbout;
  }

  const profile = store.getState().profile;
  const user = store.getState().user;

  if (UtilsProfile.isProfileEnable(user)) {

    if (profile && profile.admin) {

      buttons.push({
        content: Translator.get('stb_social_settings', 'Ajustes de Perfil'),
        props: {
          onClick: (e) => props.handleClose(e, props.callback('user-settings/idioma')),
        }
      });

      buttons.unshift({
        content: Translator.get('menu_manage_profiles_label', 'Administrar Perfiles'),
        props: {
          onClick: (e) => {
            props.handleClose(e, props.callback('profile/admin', false, null))
          }
        }
      });
    }

    profile.members && profile.members.map((member) => {

      buttons.push({
        content: member.username,
        props: {
          onClick: (e) => {
            props.handleClose(e, props.callback('profile', null, member))
          },
          imgSrc: `${member.user_image}&impolicy=resize&vwidth=27`,
          imgClassName: 'avatar',
          imgId: member.gamification_id,
          imgAlt: ''
        }
      });
    });

  } else {
    buttons.push({
      content: Translator.get('stb_social_settings', 'Ajustes de Perfil'),
      props: {
        onClick: (e) => props.handleClose(e, props.callback('user-settings/idioma')),
      }
    });
    if (props.enableSocialProfile) {
      buttons.unshift({
        content: Translator.get('social_profile_card_header', 'Mi Perfil'),
        props: {
          onClick: (e) => {
            props.handleClose(e, props.callback(`socialProfile/${props.gamificationId}`))
          }
        }
      });
    }
  }



  if (enableAbout) {
    buttons.push({
      content: Translator.get('about_card_header', 'Acerca de'),
      props: {
        onClick: (e) => {
          props.handleClose(e, props.callback('about'))
        }
      }
    });
  }

  if (props.enableSocialProfile && profile && profile.admin) {
    buttons.unshift({
      content: Translator.get('social_profile_card_header', 'Mi Perfil'),
      props: {
        onClick: (e) => {
          props.handleClose(e, props.callback(`socialProfile/${props.gamificationId}`))
        }
      }
    });
  }

  if (props.enableSessionRefresh) {
    buttons.unshift({
      content: Translator.get('btn_session_refresh', 'Refrescar sesión'),
      props: {
        onClick: (e) => {
          props.handleClose(e, props.callback(null, true))
        }
      }
    });
  }

  const LogOutButton = Utils.getApaMetadataKey('is_logout_visible', '{false}');

  if(LogOutButton) {
    buttons.push({
      content: Translator.get('social_close_session', 'Cerrar Sesion'),
      props: {
        onClick: (e) => doLogout(),
      }
    });
  }

  const p = {
    className: 'modal-social',
    buttonsAlign: 'vertical',
    buttons ,
    children: props.children,
  };

  return <ModalWrapper {...p} />;
};

export default withOnClose(ModalProfile);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalProfile.jsx